import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";

const PublicRoute = () => {
  const { user } = useContext(GlobalContext);

  if (user) {
    return <Navigate to="/bookings" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
